// No-Show Protection: payment accounts and guarantees. Provider-neutral; provider details only travel as an opaque
// `clientConfig` that the matching provider component in the widget understands.
export var GuaranteeStatus;
(function (GuaranteeStatus) {
    GuaranteeStatus["NOT_REQUESTED"] = "NOT_REQUESTED";
    GuaranteeStatus["REQUESTED"] = "REQUESTED";
    GuaranteeStatus["SECURED"] = "SECURED";
    GuaranteeStatus["RELEASED"] = "RELEASED";
    GuaranteeStatus["CHARGED"] = "CHARGED";
    GuaranteeStatus["CHARGE_FAILED"] = "CHARGE_FAILED";
    GuaranteeStatus["REFUNDED"] = "REFUNDED";
    GuaranteeStatus["WAIVED"] = "WAIVED";
})(GuaranteeStatus || (GuaranteeStatus = {}));
